// extracted by mini-css-extract-plugin
export default {"documents":"styles_documents__6-iMj","title":"styles_title__mFi+g","disclaimer":"styles_disclaimer__qYSjo"};